import { render } from "./dialogView.vue?vue&type=template&id=788af00d&scoped=true&ts=true"
import script from "./dialogView.vue?vue&type=script&lang=ts"
export * from "./dialogView.vue?vue&type=script&lang=ts"

import "./dialogView.vue?vue&type=style&index=0&id=788af00d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788af00d"]])

export default __exports__